const analyticsNames = {
	age: 'Users age',
	gender: 'User\'s gender',
	goal: 'User\'s goal',
	goal_three: 'User\'s goal',
	goalB: 'User\'s goal',
	activities_preferences: 'User\'s preferred activities',
	height: 'User\'s height',
	weight: 'User\'s current weight',
	target_weight: 'User\'s goal weight',
	diet_type: 'User\'s diet type',
	intermittent_fasting: 'Intermittent fasting',
	current_level: 'User\'s current fitness level',
	duration: 'How much time spend on workouts?',
	zones: 'User\'s preferred body zones',
	help: 'User\'s inspiration',
	frequency: 'User\'s preferred workout frequency',
	workTime: 'User\'s preferred workout duration',
	sleep: 'User\'s sleep duration',
	water: 'User\'s water intake',
	motivation: 'User\'s motivation',
	motivation_rate: 'User\'s motivation rate',
	life_changes: 'Would your life change if you reached your ideal weight?',
	last_time_ideal_weight: 'User\'s last time ideal weight',
	fat: 'Body fat'
};

export default analyticsNames;
